<div class="profile-box-area">
    <div class="profile-box-img mr-2">
      <img
        [src]="carrierInfo?.logoUrl || 'assets/images/person-ic.jpg'"
        (error)="onImgError($event)"
        alt="profile-image"
      />
    </div>
    <div class="profile-box-info">
      <h3>{{ carrierInfo?.companyName }}</h3>

      <div [ngClass]="{ active: carrierInfo?.isFavorite }" class="like-area">
        <span class="material-icons" (click)="onMarkFavourite(carrierInfo)">
          favorite_border
        </span>
      </div>
      <div>
        <ngx-stars
          #ratingChange
          initialStars="{{ carrierInfo?.rating }}"
          totalstars="{{ totalstar }}"
          [color]="'#51af57'"
          size="24px"
          [readonly]="true"
        ></ngx-stars>
      </div>

      <!-- <div class="reviews-number">
        {{ carrierInfo?.rating }} Ratings and {{ carrierInfo?.reviews }} Reviews
      </div> -->
      <div class="reviews-number">
        {{ carrierInfo.rating }}
        {{ carrierInfo.rating > 1 ? "Ratings" : "Rating" }}
        and
        {{ carrierInfo.reviews }}
        {{ carrierInfo.reviews > 1 ? "Reviews" : "Review" }}
      </div>
      <div *ngIf="bidRate != null">
      Carrier Info
      <label 
        ><strong>Bid Rate</strong>:
        {{ bidRate | currency: "USD" : "symbol" : "1.2-2" }}</label
      >
      <p>{{ carrierInfo?.memberSince }}</p>
      </div>
    </div>
</div>
